import React from 'react';
import Navbar from '../../components/Navbar';
import GeoMap from '../../components/GeoMap';

export default function FundInvestment() {
    const handleLogout = (event) => {
        event.preventDefault();
        sessionStorage.clear("token");
        window.location = "/login";
    };
    
    return (
        <>
            <div className="navbar">
                <a href="/home">
                    <img className="cpf-logo" src="/assets/cpf-logo.jpg" />
                </a>
                <button className="logout-btn" onClick={handleLogout}>
                    Log out
                </button>
            </div>
            <GeoMap />
        </>
    );
}